import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { ManagerEntity } from './manager.entity'

export class ManagersRepository extends BaseRepository<ManagerEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.userApiUrl + '/' + 'managers', token, cache)
    }
}
